import { render, staticRenderFns } from "./EmailPassword.vue?vue&type=template&id=3d618b9a&"
import script from "./EmailPassword.vue?vue&type=script&lang=js&"
export * from "./EmailPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports